import ContentStatusBadge from 'components/badge/ContentStatusBadge';
import ContentTypeBadge from 'components/badge/ContentTypeBadge';

import { NavLink } from 'react-router-dom';
import { useAtom } from 'jotai';
import { AcctState } from 'stores/atoms/acctState';
import {
  formatNumberToCurrency,
  formatRateToPercent,
  formatTimeToDate,
  getChannelAcquiredCount,
  getChannelAcquisitionRate,
  getContentImageUrl,
} from 'utils/app';
import { getContentsTypeStr } from 'utils/content';

import type { JSX } from 'react';

/**
 * ホーム画面 直近のコンテンツレポートコンポーネント
 */
export default function WsIndexContentsPublished(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useAtom(AcctState);

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-report">
        <div className="container">
          <div className="box-common">
            <h3 className="title-with-icon">
              <img
                src="/img/icon/pie-chart.svg"
                alt="直近のコンテンツレポート"
                className="icon-pie-chart"
              />
              直近のコンテンツレポート
            </h3>

            <div className="table-responsive">
              <table className="table table-top-gray">
                <thead>
                  <tr>
                    <th className="col-1">コンテンツタイトル</th>
                    <th className="col-2">参加数</th>
                    <th className="col-3">獲得リスト数</th>
                    <th className="col-4">獲得率</th>
                    <th className="col-2">完了数</th>
                    <th className="col-5">完了率</th>
                    <th className="col-6 text-center">形式</th>
                    <th className="col-6 text-center">ステータス</th>
                  </tr>
                </thead>
                <tbody className="ws-index">
                  {acctState.activeContent?.published.map(content => {
                    return (
                      <tr key={`ws-index-quizzes-published-${content.cd}`}>
                        <th>
                          <div className="d-flex d-flex-table">
                            <div className="flex-shrink-0 flex-img">
                              <img
                                src={getContentImageUrl(content.imageKey)}
                                className="img-fluid"
                              />
                            </div>
                            <div className="flex-grow-1 flex-text">
                              <NavLink
                                to={`/ws/${acctState.company.cd}/report/${getContentsTypeStr(
                                  content.contentsTypeDiv
                                )}/${content.cd}`}
                                className="detail hover quiz-title"
                              >
                                {content.title}
                              </NavLink>
                              <p className="date">
                                {formatTimeToDate(content.createdAt, 'yyyy年M月dd日 h:mm a')}
                              </p>
                            </div>
                          </div>
                        </th>
                        {/* 参加数 */}
                        <td>{formatNumberToCurrency(content.participatedCount)}</td>
                        {/* 獲得リスト数 */}
                        <td>
                          {formatNumberToCurrency(
                            getChannelAcquiredCount(
                              content.lineFlag,
                              content.mailAddressCount,
                              content.lineCount
                            )
                          )}
                        </td>
                        {/* 獲得率 */}
                        <td>{`${formatRateToPercent(
                          getChannelAcquisitionRate(
                            content.lineFlag,
                            content.mailAddressAcquisitionRate,
                            content.lineAddressAcquisitionRate
                          )
                        )}%`}</td>
                        {/* 完了数 */}
                        <td>{formatNumberToCurrency(content.answeredCount)}</td>
                        {/* 完了率 */}
                        <td>{`${formatRateToPercent(content.answeredRate)}%`}</td>
                        {/* 形式 */}
                        <td className="text-center">
                          <ContentTypeBadge contentsTypeDiv={content.contentsTypeDiv} />
                        </td>
                        {/* ステータス */}
                        <td className="text-center">
                          <ContentStatusBadge
                            statusDiv={content.statusDiv}
                            contentsTypeDiv={content.contentsTypeDiv}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="text-center">
              <NavLink
                to={`/ws/${acctState.company.cd}/report/search`}
                className="btn btn-grayish-blue"
              >
                レポート一覧
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
